<template lang="">

                <v-form  @submit.prevent="$emit('login')" id="login-form">
                  <v-text-field
                  class="mr-4 ml-4"
                    v-model="userNew.nombre"
                    label="Nombre"
                    name="nombre"
                    prepend-icon="mdi-account-circle"
                    type="text"
                    autocomplete="off"
                  >
                  </v-text-field>

                   <v-text-field
                    class="mr-4 ml-4"
                    v-model="userNew.telefono"
                    label="Teléfono"
                    name="telefono"
                    prepend-icon="mdi-phone-classic"
                    type="text"
                    autocomplete="off"
                    
                  >
                  </v-text-field>
                  <v-text-field
                   class="mr-4 ml-4"
                    v-model="userNew.email"
                    label="Email"
                    name="telefono"
                    prepend-icon="mdi-email-open"
                    type="text"
                    autocomplete="off"
                    
                  >
                  </v-text-field>
                  
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn class="mt-4 pl-8 pr-8" type="submit"  :color="colorBoton" form="login-form" v-bind:style= "{ color: colorBase}">
                    
                      Registrar como acompañante 
                     </v-btn>
                    <v-spacer></v-spacer>
                   </v-card-actions>
                </v-form>
             
</template>

<script>
//import validateMixin from "@/mixins/validation";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState(["colorBoton", "colorBase"]),
  },

  props: {
    userNew: {
      type: Object,
      required: true,
    },
  },
};
</script>